import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import KeyboardDoubleArrowLeftRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import DownloadForOfflineRoundedIcon from '@mui/icons-material/DownloadForOfflineRounded';
import InsertDriveFileRoundedIcon from "@mui/icons-material/InsertDriveFileRounded";
import LocalShippingRoundedIcon from "@mui/icons-material/LocalShippingRounded";
import ManageSearchRoundedIcon from "@mui/icons-material/ManageSearchRounded";
import DescriptionRoundedIcon from "@mui/icons-material/DescriptionRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import ExitToAppRoundedIcon from "@mui/icons-material/ExitToAppRounded";
import { storeSidebarData } from "../../redux/slices/sidebarSlice";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import ListItemButton from "@mui/material/ListItemButton";
import { useLocation, useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { alpha, useTheme } from "@mui/material/styles";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { config } from "../../config/Constants";
import ListItem from "@mui/material/ListItem";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import Drawer from "@mui/material/Drawer";
import Avatar from "@mui/material/Avatar";
import List from "@mui/material/List";
import Box from "@mui/material/Box";
import Cookies from "js-cookie";
import Axios from "axios";

const SIDEBAR_STORAGE_KEY = "cp-sidebar-expanded";
const MOBILE_SIDEBAR_EVENT = "cp-mobile-sidebar-toggle";
const EXPANDED_WIDTH = 220;
const COLLAPSED_WIDTH = 84;
const MOBILE_WIDTH = 288;

const navigationConfig = {
  "Home Page": {
    route: "/homepage",
    matches: ["/homepage"],
    icon: HomeRoundedIcon,
  },
  "Shipment Track": {
    route: "/shipmenttrack",
    matches: ["/shipmenttrack"],
    icon: LocalShippingRoundedIcon,
  },
  "Shipment-Trac": {
    route: "/shipmenttrack",
    matches: ["/shipmenttrack"],
    icon: LocalShippingRoundedIcon,
  },
  Reports: {
    route: "/reportslanding",
    matches: ["/reportslanding"],
    icon: AssessmentRoundedIcon,
  },
  Remits: {
    route: "/remits",
    matches: ["/remits"],
    icon: DescriptionRoundedIcon,
  },
  Tracking: {
    route: "/trackinglanding",
    matches: ["/trackinglanding", "/trackings", "/trackingcenter", "/statusdetails"],
    icon: ManageSearchRoundedIcon,
  },
  Forms: {
    route: "/formslanding",
    matches: ["/formslanding", "/forms"],
    icon: InsertDriveFileRoundedIcon,
  },
  "Download Center": {
    route: "/downloadcenter",
    matches: ["/downloadcenter"],
    icon: DownloadForOfflineRoundedIcon,
  },
  "Log Out": {
    icon: ExitToAppRoundedIcon,
  },
};

const getNavigationConfig = (pageName) => {
  return navigationConfig[pageName] || {
    route: undefined,
    matches: [],
    icon: InsertDriveFileRoundedIcon,
  };
};

const isNavItemActive = (pageName, pathname) => {
  const { matches = [] } = getNavigationConfig(pageName);
  return matches.some((matchPath) => pathname.startsWith(matchPath));
};

const Sidebar = React.memo(() => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [isExpanded, setIsExpanded] = useState(() => {
    const storedState = localStorage.getItem(SIDEBAR_STORAGE_KEY);
    return storedState === null ? true : storedState === "true";
  });
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  const sidebarData = useSelector((state) => state.sidebar);
  const isDrawerExpanded = isMobile ? true : isExpanded;
  const drawerWidth = isMobile ? MOBILE_WIDTH : (isExpanded ? EXPANDED_WIDTH : COLLAPSED_WIDTH);

  const getUserName = async () => {
    return Cookies.get("cp-un");
  };

  useEffect(() => {
    const getPageAccess = async () => {
      if (sidebarData.sidebarData.length === 0) {
        const userName = await getUserName();
        const response = await Axios.get(config.url.GET_PAGE_ACCESS, {
          params: {
            userName: userName,
          },
        });
        dispatch(storeSidebarData(response.data.page));
      }
    };

    getPageAccess();
  }, [dispatch, sidebarData.sidebarData.length]);

  useEffect(() => {
    localStorage.setItem(SIDEBAR_STORAGE_KEY, String(isExpanded));
  }, [isExpanded]);

  useEffect(() => {
    const handleMobileToggle = () => {
      if (isMobile) {
        setIsMobileOpen((currentState) => !currentState);
      }
    };

    window.addEventListener(MOBILE_SIDEBAR_EVENT, handleMobileToggle);
    return () => {
      window.removeEventListener(MOBILE_SIDEBAR_EVENT, handleMobileToggle);
    };
  }, [isMobile]);

  useEffect(() => {
    if (!isMobile) {
      setIsMobileOpen(false);
      return;
    }

    setIsMobileOpen(false);
  }, [isMobile, location.pathname]);

  const handleClick = async (text) => {
    if (isMobile) {
      setIsMobileOpen(false);
    }

    switch (text) {
      case "Home Page":
        navigate("/homepage");
        break;
      case "Shipment Track":
        navigate("/shipmenttrack");
        break;
      case "Shipment-Trac":
        navigate("/shipmenttrack");
        break;
      case "Reports":
        navigate("/reportslanding");
        break;
      case "Remits":
        navigate("/remits");
        break;
      case "Tracking":
        navigate("/trackinglanding");
        break;
      case "Download Center":
        navigate("/downloadcenter");
        break;
      case "Forms":
        navigate("/formslanding");
        break;
      case "Log Out":
        logout();
        break;
      default:
        break;
    }
  };

  const logout = () => {
    sessionStorage.clear();
    const cookieNames = ["gtms-cp-auth", "cp-a", "cp-csn", "cp-cn", "cp-admin", "cp-ci", "cp-un", "cp-role", "cp-vr"];
    cookieNames.forEach((cookieName) => {
      Cookies.remove(cookieName);
    });
    dispatch(storeSidebarData([]));
    setIsMobileOpen(false);
    navigate("/");
  };

  const renderNavItem = (label, options = {}) => {
    const { icon: ItemIcon } = getNavigationConfig(label);
    const isActive = !options.isUtility && isNavItemActive(label, location.pathname);
    const alignItems = isDrawerExpanded ? "flex-start" : "center";

    return (
      <ListItem key={label} disablePadding sx={{ display: "block", mb: 0.75 }}>
        <Tooltip title={!isMobile && !isDrawerExpanded ? label : ""} placement="right">
          <ListItemButton
            onClick={() => handleClick(label)}
            sx={{
              minHeight: isMobile ? 54 : 48,
              justifyContent: alignItems,
              px: isDrawerExpanded ? 1.5 : 1,
              py: isMobile ? 0.875 : 0.625,
              borderRadius: 3,
              color: isActive ? "#ffffff" : alpha("#ffffff", 0.82),
              backgroundColor: isActive ? alpha("#7ac7ff", 0.22) : "transparent",
              border: `1px solid ${isActive ? alpha("#9ad6ff", 0.35) : "transparent"}`,
              boxShadow: isActive ? `0 10px 24px ${alpha("#04101f", 0.24)}` : "none",
              transition: "background-color 180ms ease, box-shadow 180ms ease, border-color 180ms ease, transform 180ms ease",
              "&:hover": {
                backgroundColor: isActive ? alpha("#7ac7ff", 0.28) : alpha("#ffffff", 0.08),
                borderColor: isActive ? alpha("#b9e6ff", 0.4) : alpha("#ffffff", 0.08),
                transform: "translateX(1px)",
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 0,
                mr: isDrawerExpanded ? 1.5 : 0,
                justifyContent: "center",
                color: isActive ? "#ffffff" : alpha("#d9efff", 0.85),
              }}
            >
              <ItemIcon fontSize="small" />
            </ListItemIcon>
            {isDrawerExpanded && (
              <ListItemText
                primary={label}
                primaryTypographyProps={{
                  fontSize: "0.94rem",
                  fontWeight: isActive ? 700 : 500,
                  letterSpacing: "0.01em",
                }}
              />
            )}
          </ListItemButton>
        </Tooltip>
      </ListItem>
    );
  };

  return (
    <Box
      className="sidebar"
      sx={{
        width: isMobile ? 0 : drawerWidth,
        flexShrink: 0,
        transition: "width 220ms ease",
      }}
    >
      <Drawer
        variant={isMobile ? "temporary" : "permanent"}
        anchor="left"
        open={isMobile ? isMobileOpen : true}
        onClose={() => setIsMobileOpen(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
            overflowX: "hidden",
            color: "#ffffff",
            borderRight: `1px solid ${alpha("#d3ebff", 0.12)}`,
            background: "linear-gradient(180deg, #0a1d33 0%, #102846 45%, #173a5d 100%)",
            transition: "width 220ms ease",
          },
        }}
      >
        <Toolbar />
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "100%",
            px: isDrawerExpanded ? 1.5 : 1,
            py: 1.5,
            background: `linear-gradient(180deg, ${alpha("#7cc7ff", 0.08)} 0%, rgba(0, 0, 0, 0) 18%)`,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: isExpanded ? "space-between" : "center",
              gap: 1,
              mb: 1.5,
              px: 0.5,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", minWidth: 0, gap: 1.25 }}>
              <Avatar
                sx={{
                  width: 34,
                  height: 34,
                  bgcolor: alpha("#8fd6ff", 0.16),
                  color: "#f0f8ff",
                  border: `1px solid ${alpha("#ffffff", 0.16)}`,
                  fontWeight: 700,
                  fontSize: "0.85rem",
                }}
              >
                CP
              </Avatar>
              {isDrawerExpanded && (
                <Box sx={{ minWidth: 0 }}>
                  <Typography sx={{ fontSize: "0.9rem", fontWeight: 700, lineHeight: 1.2 }}>
                    Customer Portal
                  </Typography>
                  <Typography sx={{ fontSize: "0.72rem", color: alpha("#d4e7f7", 0.78), letterSpacing: "0.08em", textTransform: "uppercase" }}>
                    Navigation
                  </Typography>
                </Box>
              )}
            </Box>
            {!isMobile && (
              <Tooltip title={isExpanded ? "Collapse sidebar" : "Expand sidebar"} placement="right">
                <IconButton
                  onClick={() => setIsExpanded((currentState) => !currentState)}
                  size="small"
                  sx={{
                    width: 34,
                    height: 34,
                    color: "#ffffff",
                    border: `1px solid ${alpha("#ffffff", 0.12)}`,
                    backgroundColor: alpha("#ffffff", 0.05),
                    "&:hover": {
                      backgroundColor: alpha("#ffffff", 0.12),
                    },
                  }}
                >
                  {isExpanded ? <KeyboardDoubleArrowLeftRoundedIcon fontSize="small" /> : <KeyboardDoubleArrowRightRoundedIcon fontSize="small" />}
                </IconButton>
              </Tooltip>
            )}
          </Box>

          <Divider sx={{ mb: 1.5, borderColor: alpha("#d3ebff", 0.12) }} />

          <List sx={{ pt: 0 }}>
            {sidebarData.sidebarData.map((obj) => renderNavItem(obj.PAGE_NAME))}
          </List>

          <Box sx={{ mt: "auto" }}>
            <Divider sx={{ mb: 1.5, borderColor: alpha("#d3ebff", 0.12) }} />
            {isDrawerExpanded && (
              <Typography
                sx={{
                  px: 1.5,
                  pb: 1,
                  fontSize: "0.72rem",
                  color: alpha("#d4e7f7", 0.68),
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                }}
              >
                Session
              </Typography>
            )}
            <List sx={{ pt: 0 }}>
              {renderNavItem("Log Out", { isUtility: true })}
            </List>
          </Box>
        </Box>
      </Drawer>
    </Box>
  );
});

export default Sidebar;
